export const GOOGLE_ADS_WEBSITE_PURCHASE_ACTION_ID = '7339787189';
export const GOOGLE_ADS_WEBSITE_PURCHASE_SEND_TO =
  'AW-17646508237/Oc12CLWH8asbEM2xwd5B';
export const GOOGLE_ADS_TRANSACTION_ID_MAX_CHARACTERS = 64;
